import React from 'react'
import { css } from '@linaria/core'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import PropTypes from 'prop-types'
import List from './List'
import Divider from '../divider'
import { useListContext } from './ListContext'

const listSubSectionCss = css`
  list-style: none;
  padding: 20px 0 0;
  margin: 0;
  &:focus {
    outline: none;
  }
`

export default function ListSubSection({ children, heading, fullWidth, ...props }) {
  const { bleedToContainer } = useListContext()

  return (
    <li className={listSubSectionCss} {...sanitizeProps(props)}>
      <section>
        <Divider label={heading} fullWidth={fullWidth} />
        <List bleedToContainer={bleedToContainer}>{children}</List>
      </section>
    </li>
  )
}

ListSubSection.propTypes = {
  /** The ListItems to display in the sub-section. */
  children: PropTypes.node.isRequired,

  /** Heading to display for the sub-section. */
  heading: PropTypes.string.isRequired,

  /** Bleed the divider line to the sides */
  fullWidth: PropTypes.bool,
}
